"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _reactLottie = _interopRequireDefault(require("react-lottie"));
var _styledComponents = require("styled-components");
var animationData = _interopRequireWildcard(require("../../assets/animations/clock.json"));
var _theme = require("../utils/theme");
var _excluded = ["color", "theme", "width", "height"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var LoadingAnimation = function LoadingAnimation(_ref) {
  var color = _ref.color,
    _ref$theme = _ref.theme,
    theme = _ref$theme === void 0 ? _theme.defaultTheme : _ref$theme,
    _ref$width = _ref.width,
    width = _ref$width === void 0 ? 80 : _ref$width,
    _ref$height = _ref.height,
    height = _ref$height === void 0 ? 80 : _ref$height,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice'
    }
  };
  return /*#__PURE__*/_react["default"].createElement(_styledComponents.ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/_react["default"].createElement(_reactLottie["default"], (0, _extends2["default"])({
    isStopped: false,
    isPaused: false,
    isClickToPauseDisabled: true,
    options: defaultOptions,
    height: width,
    width: height
  }, props)));
};
var _default = exports["default"] = LoadingAnimation;